import {IRegion} from '../common/type';
import {PageInfo} from '../common/util/PageRouter';

export type IGlobalLoginMethod = 'FB' | 'GG' | 'AP' | 'LN';
export type ILoginMethod = IGlobalLoginMethod | 'KA' | 'DA';

export enum UserState {
  Login,
}

export enum ClientType {
  Ios = 'IA',
  Android = 'AA',
  Pc = 'PW',
  Mobile = 'MW',
}

// 다음에 처리해야할 단계
export enum NextAuthStep {
  NeedTermAcceptance = 'NTA',
  NeedAuthFinish = 'NAF',
  NeedEvictionConfirmation = 'NEC',
  NeedUserIdVerification = 'NUD',
  NeedParentIdVerification = 'NPD',
  NeedReactivateAuthFinish = 'NRAF',
  NeedReactivateAuth = 'NRA',
}

export enum UserStatus {
  Ok = 'OK',
  SignOff = 'SF',
  BlockedBySecurity = 'BS',
  BlockedByManager = 'BM',
  RequiredTermNotAgreed = 'TN',
}

export enum SignupType {
  Facebook = 'FB',
  Google = 'GG',
  Apple = 'AP',
}
export interface IUser {
  state: UserState;
  id: string;
  email: string;
  accessToken: string;
  nickname: string;
  csId: string;
  profileUrl: string;
  joinMethod: ILoginMethod;
  currentLoginMethod: ILoginMethod;
  authList?: IAuth[];
  redeemCode: string;
  userStatus: UserStatus;
  createDt: number;
  blockedAt?: string;
  isIdentityVerified: boolean;
  region: IRegion;
  providerId?: string;
  isAdult: boolean;
  isChild: boolean;
  isThirdAdAgree: boolean;
  kakaoAppUserId?: string;
}

interface IAuth {
  nickname: string;
  loginMethod: ILoginMethod;
}

export interface IApiParamsAuthResult {
  sessionId?: string;
  signupType?: SignupType;
  currentStatus?: string;
  authStatus?: NextAuthStep;
  invalidate?: boolean;
  isSignUp?: boolean;
  sessionRegion?: IRegion;
  errorType?: string;
  needReload?: boolean;
  verificationSessionId?: string; // 14세 미만 인증을 위한 sessionId
}

export interface ILastLoginAuth {
  emailOrName: string;
  loginMethod: IGlobalLoginMethod;
}

export type IAuthModalType = 'login' | 'lastLogin';

export interface IAuthModal {
  show: boolean;
  titleType?: IAuthModalTitleType;
  pageInfoAfterClose?: PageInfo;
}

export type IAuthModalTitleType =
  | 'onBoarding'
  | 'adult'
  | 'waitfree'
  | 'nextEpisode'
  | 'loginButton';

export type IIdVerificationModalType =
  | 'under14'
  | 'parent'
  | 'limitCash'
  | 'adult';

export interface ITermsItem {
  id: number;
  detailPath?: string;
  isRequired: boolean;
  title: string;
  version: string;
  // 아래 두 값은 사용하지 않는 값 (연령 체크가 필요하면 사용해야함)
  // ageCheck: boolean;
  // minAge: number;
}
